export default {
    namespaced: true,
    state: {
        id: null,
        firstName: null,
        lastName: null,
        appId: null,
        appSecret: null,
        companyName: null,
        email: null,
        phone: null,
        isVerify: true,
        origin: null,
        profilePicture: null,
        isOffline: true,
        expiredAt: null,
        serviceCateAndType: null,
        roleNames: [],
        subscriptPlan: {
            isSubscript: false,
            planType: 1,
            userCount: 0,
            unitPrice: 0,
            validFrom: null,
            validTo: null,
            nextPayment: null,
            isAutoRenew: false,
        },
        chatSettings: {
            isHideSystemChat: false,
            isTranslationOn: false,
        },
        profilePicture: null,
    },
    getters: {},
    mutations: {
        UPDATE_PROFILE(state, val) {
            state.firstName = val.firstName;
            state.companyName = val.companyName;
            state.appId = val.appId;
            state.appSecret = val.appSecret;
            state.isVerify = val.isVerify;
            state.origin = val.origin;
            state.profilePicture = val.profilePicture;
            state.chatSettings.isOffline = val.isOffline;
            state.isOffline = val.isOffline;
            state.expiredAt = val.expiredAt;
            state.subscriptPlan.isSubscript = val.subscriptPlan.isSubscript;
            state.subscriptPlan.planType = val.subscriptPlan.planType;
            state.subscriptPlan.userCount = val.subscriptPlan.userCount;
            state.subscriptPlan.unitPrice = val.subscriptPlan.unitPrice;
            state.subscriptPlan.validFrom = val.subscriptPlan.validFrom;
            state.subscriptPlan.validTo = val.subscriptPlan.validTo;
            state.subscriptPlan.nextPayment = val.subscriptPlan.nextPayment;
            state.subscriptPlan.isAutoRenew = val.subscriptPlan.isAutoRenew;
            state.serviceCateAndType = val.serviceCateAndType;
            state.roleNames = val.roleNames;
            state.profilePicture = val.profilePicture;
            state = { ...val }
        },
        UPDATE_SETTING(state, val) {
            state.chatSettings.isHideSystemChat = val.isTranslateOn,
                state.chatSettings.isTranslationOn = val.isTranslationOn
        },
    },
    actions: {},
}
